const { GRID_SIZE } = require('./board-constants.js');
const { PIECES } = require('./pieces.js');

function to1d (x, y) {
  return x + y * GRID_SIZE;
}

function to2d (p) {
  return { x: p % GRID_SIZE, y: Math.floor(p / GRID_SIZE) };
}

function inBounds (x, y) {
  return x >= 0 && y >= 0 && x < GRID_SIZE && y < GRID_SIZE;
}

function overlaps (grid, cells, x, y) {
  if (!inBounds(x, y)) {
    return true;
  }
  for (let cell of cells) {
    if (!inBounds(x + cell.x, y + cell.y)
        || grid[to1d(x + cell.x, y + cell.y)] !== null) {
      return true;
    }
  }
  return false;
}

function getPieceSize (cells) {
  const w = Math.max(...cells.map((c) => c.x));
  const h = Math.max(...cells.map((c) => c.y));
  return { w, h };
}

function cellToPos (p, data) {
  if (!data) return null;
  let { x, y } = to2d(p);
  const { cells } = PIECES[data.ref];
  x -= data.offset.x;
  y -= data.offset.y;
  const { w, h } = getPieceSize(cells);
  if (x < 0) { x = 0; }
  if (y < 0) { y = 0; }
  if (x + w >= GRID_SIZE) {
    x = GRID_SIZE - 1 - w;
  }
  if (y + h >= GRID_SIZE) {
    y = GRID_SIZE - 1 - h;
  }
  return { x, y, cells };
}

module.exports = {
  to1d,
  to2d,
  getPieceSize,
  inBounds,
  overlaps,
  cellToPos
};
